import { flip, prop } from 'ramda'

const lookup = flip(prop)

export default lookup
